@if (loading()) {
  <app-loading-card title="Loading your papers...">
    <p>Assembling research Avengers, chasing rogue citations, and convincing PDFs to cooperate. Almost there!</p>
  </app-loading-card>
}


@if (papers.length > 0) {
  <div class="research-paper-list">
    <div class="filter-wrapper">
      <app-research-paper-smart-search
        [screeningCriteria]="criteria()"
        (searchValue)="applySearch($event)"
        (changeFilter)="changeFilter($event)"
      ></app-research-paper-smart-search>

      @if (filters().length > 0) {
        <!-- TODO
             tourAnchor="paper-list-filter"-->
        <div class="filter-wrapper--filter"
        >
          <mat-chip-listbox multiple>
            @for (filter of filters(); track filter) {
              <mat-chip-option [selected]="selectedFilter[$index]"
                               (selectionChange)="applyFilter($event, $index)"
                               [matBadge]="getBadgeCount(filter)" matBadgeSize="large"
              >{{ filter }}
              </mat-chip-option>
            }
          </mat-chip-listbox>
        </div>
      }
    </div>

    @if (paginatedPapers.length > 0) {
      <div class="research-paper-list--content">
        @if (isSelectList()) {
          <div class="select-all-wrapper">
            <mat-checkbox (change)="$event ? toggleAllRows() : null"
                          [checked]="selection.hasValue() && isAllSelected()"
                          [indeterminate]="selection.hasValue() && !isAllSelected()"
                          aria-label="Select all">
              Select all
            </mat-checkbox>
            <p>{{ selection.selected.length }} selected</p>
          </div>
        }
        @for (paper of paginatedPapers; track paper.id) {
          @if (isSelectList()) {
            <mat-checkbox (click)="$event.stopPropagation()"
                          (change)="selectPaper($event,paper)"
                          [checked]="selection.isSelected(paper)"
                          class="checkbox"
                          [aria-label]="paper.title">
              <app-research-paper-card
                [class.clickable]="disablePapersDialog()"
                [disablePapersDialog]="disablePapersDialog()"
                (click)="clickItem(paper)"
                [paper]="paper"
                [editable]="editMode()"
                [linkSelectedTab]="linkSelectedTab()"
              ></app-research-paper-card>
            </mat-checkbox>
          } @else {
            <app-research-paper-card
              [class.clickable]="disablePapersDialog()"
              [disablePapersDialog]="disablePapersDialog()"
              (click)="clickItem(paper)"
              [paper]="paper"
              [editable]="true"
            ></app-research-paper-card>
          }
        }
      </div>
      <mat-paginator
        [length]="filteredPapers.length"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [pageSizeOptions]="[5, 10, 25, 100]"
        (page)="handlePageEvent($event)"></mat-paginator>

    } @else {

      <p class="no-papers-message">
        No papers match your filter. Please try adjusting your filters or
        <button mat-button color="primary" (click)="resetFilters()">Reset all filters</button>
        <br>If this doesn't help your problem try to <a href="javascript:location.reload()">reload
        the page</a>.
      </p>

    }
  </div>
} @else {

  <div class="whats-next">

    @if (alreadySearched()) {
      <app-empty-state
        title="No Papers Found"
        subtitle="Or no papers were found that match your current screening settings.
    This could be because your filters are too strict or because no suitable studies are currently available."
      ></app-empty-state>
    }
    @if (editMode()) {
      <app-empty-state
        title="Start your research journey"
        subtitle="Once your screening settings have been verified, you can start your research journey."
        primaryButtonLabel="Start your research journey now"
        icon="query_stats"
        [primaryButtonEnabled]="true"
        (cta)="startResearch()"
      ></app-empty-state>
    }
  </div>
}
